export const brandInfo = {
  name: "华丽的外出",
  englishName: "Huali De Waichu",
  tagline: "每一次出门都是时尚宣言",
  founded: 2020,
  description: "「华丽的外出」是一个专注于女性出行穿搭与生活方式的高端内容平台。我们致力于为追求品质生活的都市女性提供专业的穿搭攻略、妆容教程、配饰搭配指南和仪态修炼方法，帮助每一位女性在任何场合都能自信绽放，散发独特魅力。",
  mission: "让每一位女性都能通过穿搭表达自我，在每一次外出中感受自信与美丽的力量。",
  vision: "成为中国最具影响力的女性时尚穿搭平台，引领优雅与自信的生活方式。",
  email: "contact@hualidewaichu.com",
  wechat: "华丽的外出",
  xiaohongshu: "华丽的外出",
  address: "上海市静安区南京西路1266号恒隆广场",
  workingHours: "周一至周五 9:00 - 18:00",
  stats: {
    articles: 1280,
    readers: 350000,
    categories: 5,
    years: 5,
  },
  milestones: [
    { year: "2020", title: "品牌创立", description: "「华丽的外出」正式成立，以微信公众号为起点，开始分享穿搭灵感。" },
    { year: "2021", title: "内容矩阵扩展", description: "入驻小红书、抖音等平台，全平台粉丝突破10万，开始系统化产出穿搭内容。" },
    { year: "2022", title: "专业团队组建", description: "组建专业造型师和编辑团队，内容质量全面提升，获得行业认可。" },
    { year: "2023", title: "用户突破30万", description: "全平台用户突破30万，成为女性穿搭领域的知名品牌。" },
    { year: "2024", title: "全新官网升级", description: "推出全新官方网站，为读者提供更优质的浏览体验和更丰富的内容服务。" },
  ],
  values: [
    { title: "专业", description: "所有内容均由专业造型师和资深编辑团队精心打造，确保每一篇文章的专业性和实用性。" },
    { title: "真实", description: "坚持使用真人实拍和真实穿搭案例，拒绝过度PS和虚假推荐，用真诚赢得读者的信任。" },
    { title: "包容", description: "美丽没有标准答案。我们鼓励每一种风格的表达，尊重每一位女性独特的审美选择。" },
    { title: "创新", description: "持续关注全球时尚趋势，将国际前沿的穿搭理念与中国女性的实际需求相结合，不断推陈出新。" },
  ],
  testimonials: [
    {
      name: "林小雨",
      role: "金融行业从业者",
      content: "关注「华丽的外出」三年了，从穿搭小白变成了办公室公认的「会穿女孩」。每一篇文章都很实用，特别喜欢通勤穿搭系列，帮我省了很多早上搭配的时间！",
      avatar: "https://readdy.ai/api/search-image?query=Elegant%20professional%20Asian%20woman%20portrait%20with%20warm%20smile%2C%20natural%20lighting%2C%20soft%20cream%20background%2C%20clean%20minimal%20headshot%2C%20friendly%20approachable%20expression&width=200&height=200&seq=testimonial-1&orientation=squarish",
    },
    {
      name: "王思涵",
      role: "品牌公关经理",
      content: "工作中经常需要出席各种活动，「华丽的外出」的场合穿搭指南简直就是我的救命稻草。每次不知道该穿什么的时候就来看看，总能找到灵感。晚宴妆容教程也超级实用！",
      avatar: "https://readdy.ai/api/search-image?query=Confident%20professional%20Asian%20woman%20portrait%20with%20elegant%20expression%2C%20soft%20studio%20lighting%2C%20warm%20neutral%20background%2C%20clean%20headshot%2C%20sophisticated%20professional%20look&width=200&height=200&seq=testimonial-2&orientation=squarish",
    },
    {
      name: "张悦然",
      role: "设计师",
      content: "作为一个对审美有高要求的设计师，我真的很挑内容平台。「华丽的外出」的视觉呈现和内容质量都让我非常满意。配饰搭配的文章特别有品位，每一篇都想收藏！",
      avatar: "https://readdy.ai/api/search-image?query=Stylish%20creative%20Asian%20woman%20portrait%20with%20artistic%20vibe%2C%20soft%20natural%20lighting%2C%20warm%20cream%20background%2C%20clean%20minimal%20headshot%2C%20creative%20confident%20expression&width=200&height=200&seq=testimonial-3&orientation=squarish",
    },
  ],
};